import { render, staticRenderFns } from "./PopupEditImage.vue?vue&type=template&id=79772a66&scoped=true"
import script from "./PopupEditImage.vue?vue&type=script&lang=js"
export * from "./PopupEditImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79772a66",
  null
  
)

export default component.exports